define('core/modules/nav',["jquery", "core/global/state", "libs/enquire", "core/ef_plugins/shamone"], function ($, state, enquire) {
    return {
        init: function() {
            console.log('nav');

            var plugin,
                navSelector = '.nav-sitewide',
                $nav = $(navSelector),
                $mainNav = $('#main-nav'),
                $utilityNav = $('#utility-nav'),
                $ctas = $('#nav-utility-ctas');

            var windowWidth = state.getBreakpoint();

            var utilityDropdown = {
                close: function($el) {
                    $el.removeClass('is-open');
                    $(document).off('touchstart.utilitysubnav');
                },

                setup: function () {
                    var self = this;

                    // set up logged-in dropdown on click event on touch devices (uses css hover on non-touch)
                    if (EFTOURS.device.isTouch && $nav.hasClass('is-logged-in')) {
                        $('.nav-utility-haschildren > .nav-utility-link').on('click.utilitysubnav', function (evt) {
                            var $parent = $(this).parent();
                            evt.preventDefault();
                            evt.stopPropagation();

                            if ($parent.hasClass('is-open')) {
                                self.close($parent);
                            }
                            else {
                                $parent.addClass('is-open');
                                $(document).on('touchstart.utilitysubnav', function (event) {
                                    if (!$(event.target).parents('.nav-utility-haschildren').is($parent)) {
                                        self.close($parent);
                                    }
                                });
                            }
                        });
                    }
                },

                breakdown: function () {
                    var self = this;
                    if (EFTOURS.device.isTouch && $nav.hasClass('is-logged-in')) {
                        self.close($('.nav-utility-haschildren > .nav-utility-link').parent());

                        // clear out handler
                        $('.nav-utility-haschildren > .nav-utility-link').off('click.utilitysubnav');
                    }
                }
            };

            //setup the utility dropdown
            if (windowWidth >= 865) {
                console.log("utility setup on load");
                utilityDropdown.setup();
            }

            // if not fixed width, setup shamone, etc.
            if (!state.oldIe() && !EFTOURS.config.isfixedwidth) {
                function swapNav() {
                    if ($('html').hasClass('lt-ie10')) {
                        //swap utility nav and main nav position
                        $mainNav.insertBefore($utilityNav);
                        $ctas.detach().appendTo($utilityNav);
                    }
                };

                function resetNav() {
                    if ($('html').hasClass('lt-ie10')) {
                        // swap header CTA and main nav position back
                        $utilityNav.insertBefore($mainNav);
                        $ctas.detach().prependTo($utilityNav);
                    }
                };

                // Side nav setup / destroy

                enquire.register("screen and (max-width : 864px)", {
                        match: function () {
                            console.log("shamone match");

                            utilityDropdown.breakdown();

                            // side slide nav
                            $('.hee-hee').shamone({
                                'navSelector': navSelector,
                                'contentPanelSelector': '.site-wrapper',
                                'slideDirection': 'left',
                                'openCallback': function () { dataLayer.push({ 'event': 'click', 'context': 'MainNav', 'action': 'open' }); },
                                'closeCallback': function () { dataLayer.push({ 'event': 'click', 'context': 'MainNav', 'action': 'close' }); },
                                'setupCallback': function () { swapNav(); },
                                'destroyCallback': function () { resetNav(); },
                                'linksDisabledElement': '#main'
                            });
                        },

                        unmatch: function () {
                            console.log("shamone unmatch");

                            // destroy any existing side slide nav
                            plugin = $('.hee-hee').data('plugin_shamone');
                            if (plugin !== undefined)
                                plugin.destroy();

                            // setup utility dropdown
                            utilityDropdown.setup();
                        }
                    });

            }
        }
    }
});
